import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=1adeb8d4&scoped=true"
import script from "./Permits.vue?vue&type=script&lang=js"
export * from "./Permits.vue?vue&type=script&lang=js"
import style0 from "./Permits.vue?vue&type=style&index=0&id=1adeb8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adeb8d4",
  null
  
)

export default component.exports